import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {Select, Store} from "@ngxs/store";
import {ResourceGroupsActions} from "../state/resource-groups.actions";
import {Session} from "../../../services/session";
import {ResourceGroupsState} from "../state/resource-groups.state";
import {Observable, Subscription} from "rxjs";
import {Resource} from "../../model/resource";
import {map} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {EditComponent} from "../edit/edit.component";
import {ConfirmDialogComponent, ConfirmDialogModel} from "../../../shared/confirm-dialog/confirm-dialog.component";
import {ResourceGroup} from "../../model/resource-group";

class ListItem {
  id: string;
  name: string;

  constructor(resource: Resource) {
    this.id = resource.id;
    this.name = resource.name;
  }
}

@Component({
  selector: 'resource-groups-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {
  displayedColumns = ['name', 'operations'];
  dataSource = new MatTableDataSource<ListItem>();

  private readonly serviceProvider: string;
  @Select(ResourceGroupsState.items) public items$: Observable<Resource[]>;

  @ViewChild(MatSort) sort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  private subscriptions: Subscription[] = [];

  constructor(private store: Store, private session: Session, private dialog: MatDialog) {
    this.serviceProvider = this.session.serviceProviderIdentifier;

    this.subscriptions.push(
      this.items$.pipe(
        map((items) => items?.map(item => new ListItem(item)))
      ).subscribe(
        (data) => {
          this.dataSource.data = data;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      )
    )
  }

  ngOnInit(): void {
    this.store.dispatch(new ResourceGroupsActions.LoadAll());
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(it => it.unsubscribe());
  }


  addResource() {
    this.store.dispatch(new ResourceGroupsActions.Create());
    this.dialog.open(EditComponent, {width: '350px'});
  }

  edit(resourceGroup: ResourceGroup) {
    this.store.dispatch(new ResourceGroupsActions.Edit(resourceGroup.id));
    this.dialog.open(EditComponent, {width: '350px'});
  }

  delete(resourceGroup: ResourceGroup) {
    const dialogData = new ConfirmDialogModel('Gruppe löschen', 'Willst Du die Gruppe "' + resourceGroup.name + '" löschen?');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    this.subscriptions.push(dialogRef.afterClosed().subscribe(dialogResult => {
        if (dialogResult == false)
          return;

        this.store.dispatch(new ResourceGroupsActions.Delete(resourceGroup.id));
      })
    );
  }
}
